export default __webpack_public_path__ + "static/media/03-3D-(4-3).88d34260.jpg";